function Compare() {}
Compare.prototype.initAddToCompare = function(items) {
    var ajax = new Ajax();
    var self = this;
    if ($('.grid__item .contact-form').length === 0) {
        return;
    }
    var selector = $('.contact-form .nt-compare');
    if (items) {
        var arrayItem = [];
        items.forEach(function(item) {
            arrayItem.push($(item).find('.contact-form .nt-compare')[0]);
        });
        selector = arrayItem;
    }
    $(selector).click(function(event) {
        var form = $(this).closest('form');
        var name = '';
        if ($('.product-single').length > 0) {
            name = $(this).parents('.nt-product-content').find('.nt-product-page-top h1').html();
        } else {
            name = $(this).parents('.nt-grid-item-inner').find('.nt-product-item-name a').html();
        }
        ajaxAddToCompare(form, this, name);
        event.preventDefault();
        return false;
    });

    function ajaxAddToCompare(form, ele, name) {
        $.ajax({
            type: "post",
            url: "/contact",
            data: form.serialize(),
            beforeSend: function() {
                Ajax.showLoading();
            },
            success: function(msg) {
                toastr.success('<span style="font-weight:bold">' + name + '</span>' + 'was successfully added to your' + '<a href="/pages/compare">' + 'Compare' + '</a>!');
                var productId = $(ele).attr('data-id');
                $('.compare-' + productId).addClass('checked-compare');
                Ajax.hideLoading();
            },
            error: function(xhr, text) {
                toastr.error('Can&#39;t add to compare!');
                Ajax.hideLoading();
            }
        });
    };
}
Compare.prototype.initRemoveToCompare = function() {
    var ajax = new Ajax();
    var self = this;
    $('.contact-form .remove-compare').click(function(event) {
        var form = $(this).closest('form');
        var index = $('.contact-form .remove-compare').index(this);
        var table = $(this).parents('table');
        var name = table.find('.compare-title td a').get(index).innerHTML;
        ajaxRemoveToCompare(form, name);
        event.preventDefault();
        return false;
    });

    function ajaxRemoveToCompare(form, name) {
        $.ajax({
            type: "post",
            url: "/contact",
            data: form.serialize(),
            beforeSend: function() {
                Ajax.showLoading();
            },
            success: function(data) {
                toastr.success('<span style="font-weight:bold">' + name + '</span>' + 'was successfully removed');
                var currentTable = $('.nt-compare-page');
                var newTable = $(data).find('.nt-compare-page');
                currentTable.replaceWith(newTable);
                self.initRemoveToCompare();
                Ajax.hideLoading();
            },
            error: function(xhr, text) {
                toastr.error('Can&#39;t add to compare!');
                Ajax.hideLoading();
            }
        });
    };
}
